import { Component, h } from '@stencil/core';

@Component({
  tag: 'clothing-icon',
  shadow: true,
})
export class ClothingIcon {
  render() {
    return (
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="0.0012207" y="0.000488281" width="40" height="39.999" rx="8" fill="#F9B98E" />
        <path
          d="M32.0012 14.6355C32.0012 12.3345 30.7802 10.2495 28.8152 9.19549C27.3382 8.40249 25.7832 8.00049 24.1912 8.00049H15.8112C14.2192 8.00049 12.6632 8.40249 11.1862 9.19549C9.22222 10.2495 8.00122 12.3345 8.00122 14.6355V28.9995H12.0012V31.9995H28.0012V28.9755H32.0012V14.6355ZM22.9022 9.99949C22.4472 11.1955 21.3082 11.9995 20.0012 11.9995C18.6942 11.9995 17.5552 11.1955 17.1002 9.99949H22.9022ZM30.0012 26.9755H28.0012V14.9995H26.0012V29.9995H14.0012V14.9995H12.0012V26.9995H10.0012V14.6355C10.0012 13.0725 10.8182 11.6625 12.1322 10.9565C13.0712 10.4525 14.0452 10.1465 15.0372 10.0415L15.0272 10.0435C15.5692 12.3725 17.6142 13.9995 20.0012 13.9995C22.3882 13.9995 24.4332 12.3725 24.9752 10.0435L24.9652 10.0415C25.9562 10.1465 26.9312 10.4525 27.8712 10.9565C29.1852 11.6625 30.0022 13.0725 30.0022 14.6355L30.0012 26.9755Z"
          fill="#333333"
        />
      </svg>
    );
  }
}
